import "./style.css";
import LangUtil from "./utils/Lang";
import { iterate } from "./utils/utils";
import MainExperience from "./Experiences/MainExperience/MainExperience";

async function setLangBasedContent() {
  const elements = [];
  const Lang = new LangUtil();
  const langCode = Lang.getLangCode();

  const responseRo = await fetch("/lang/main/ro.json");
  const responseEn = await fetch("/lang/main/en.json");
  const dataRo = await responseRo.json();
  const dataEn = await responseEn.json();

  if (langCode === "ro") {
    iterate(dataRo, elements);
    const Language = new LangUtil(elements);
    Language.setLangMain(Object.keys(dataRo));
    Language.set3DText(dataRo);
  } else {
    iterate(dataEn, elements);
    const Language = new LangUtil(elements);
    Language.setLangMain(Object.keys(dataEn));
    Language.set3DText(dataEn);
  }
}

setLangBasedContent();

const experience = new MainExperience(
  document.querySelector("#mainExperience")
);
